// extracted by mini-css-extract-plugin
export var form = "ContactForm-module--form--e8c6c";
export var input = "ContactForm-module--input--b55c9";
export var submit = "ContactForm-module--submit--e0b7d";